{
  "name": "ffd-web",
  "version": "0.0.487-temp-uat-release-11-04-17.3cb964d4",
  "license": "MIT",
  "scripts": {
    "audit": "npx audit-ci@^7 --config audit-ci.jsonc",
    "check:i18n-sheet": "tsx scripts/i18n-sheet-check.ts",
    "check:i18n-used-keys": "tsx scripts/i18n-used-keys-check.ts",
    "edit:i18n-sheet": "tsx --env-file=.env scripts/i18n-sheet-edit.ts",
    "export:i18n-sheet": "tsx --env-file=.env scripts/i18n-sheet-export.ts",
    "lint:file-names": "node file-name-spell-check.js && cspell lint \"tmp/file-names.txt\"",
    "lint:eslint": "nx run-many --target=lint --all=true",
    "start": "nx run ffd:serve:development",
    "start:local": "nx run ffd:serve:development --proxy-config proxy.conf.json",
    "prepare": "husky install",
    "generate-icons": "nx run @libs/icons:generate",
    "sentry:sourcemaps": "npx @sentry/cli@2.56.0 sourcemaps inject --org ffd-uw --project javascript-angular ./dist/apps/ffd && @sentry/cli@2.56.0 sourcemaps upload --org ffd-uw --project javascript-angular ./dist/apps/ffd",
    "sentry:inject": "npx @sentry/cli@2.56.0 sourcemaps inject --org ffd-uw --project javascript-angular ./dist/apps/ffd",
    "sentry:upload": "npx @sentry/cli@2.56.0 sourcemaps upload --org ffd-uw --project javascript-angular ./dist/apps/ffd"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.25",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.25",
    "@angular/compiler": "21.2.25",
    "@angular/core": "21.2.25",
    "@angular/forms": "21.2.25",
    "@angular/material": "21.2.14",
    "@angular/material-luxon-adapter": "21.2.14",
    "@angular/platform-browser": "21.2.25",
    "@angular/platform-browser-dynamic": "21.2.25",
    "@angular/router": "21.2.25",
    "@deepgram/sdk": "5.16.0",
    "@ffd/api-client": "0.18.33-mr-547.afe836fb",
    "@ngneat/svg-icon": "7.1.0",
    "@ngneat/until-destroy": "10.0.0",
    "@ngrx/component-store": "21.0.1",
    "@ngrx/effects": "21.0.1",
    "@ngrx/entity": "21.0.1",
    "@ngrx/operators": "21.0.1",
    "@ngrx/router-store": "21.0.1",
    "@ngrx/signals": "21.0.1",
    "@ngrx/store": "21.0.1",
    "@ngrx/store-devtools": "21.0.1",
    "@rxjs-ninja/rxjs-utility": "5.1.3",
    "@schaman/angular-config": "1.0.0",
    "@sentry/angular": "10.18.0",
    "@sentry/cli": "2.56.0",
    "@stripe/stripe-js": "9.0.0",
    "@tailwindcss/container-queries": "0.1.1",
    "@types/marked": "6.0.0",
    "angular-google-tag-manager": "1.9.0",
    "angular2-prettyjson": "3.0.1",
    "angularx-qrcode": "18.0.2",
    "assert": "2.1.0",
    "d3": "7.8.5",
    "get-blob-duration": "1.1.2",
    "jwt-decode": "4.0.0",
    "libphonenumber-js": "1.13.8",
    "lodash": "4.18.0",
    "lottie-web": "5.12.2",
    "luxon": "3.4.4",
    "marked": "9.1.6",
    "ngx-lottie": "13.0.1",
    "ngx-markdown": "19.1.1",
    "ngx-mask": "21.0.1",
    "openai": "4.80.1",
    "rxjs": "7.8.2",
    "socket.io-client": "4.8.3",
    "three": "^0.155.0",
    "tslib": "^2.3.0",
    "wavesurfer.js": "7.7.15",
    "zone.js": "~0.14.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.27",
    "@angular-devkit/core": "21.2.15",
    "@angular-devkit/schematics": "21.2.15",
    "@angular-eslint/builder": "21.2.0",
    "@angular-eslint/eslint-plugin": "21.2.0",
    "@angular-eslint/eslint-plugin-template": "21.2.0",
    "@angular-eslint/schematics": "21.2.0",
    "@angular-eslint/template-parser": "21.2.0",
    "@angular/cli": "21.2.15",
    "@angular/compiler-cli": "21.2.25",
    "@angular/language-service": "21.2.25",
    "@commitlint/cli": "19.8.0",
    "@commitlint/config-conventional": "19.8.0",
    "@commitlint/types": "19.8.0",
    "@cspell/cspell-types": "8.0.0",
    "@ngneat/eslint-plugin-reactive-forms": "4.0.0",
    "@ngneat/svg-generator": "7.0.2",
    "@ngrx/entity": "19.2.1",
    "@ngrx/eslint-plugin": "19.1.0",
    "@ngx-translate/core": "16.0.4",
    "@ngx-translate/http-loader": "~8.0.0",
    "@nx/angular": "22.4.5",
    "@nx/devkit": "20.8.0",
    "@nx/eslint": "20.8.0",
    "@nx/eslint-plugin": "20.8.0",
    "@nx/jest": "20.8.0",
    "@nx/js": "20.8.0",
    "@nx/playwright": "20.8.0",
    "@nx/web": "20.8.0",
    "@playwright/test": "1.58.1",
    "@schematics/angular": "21.1.2",
    "@swc-node/register": "1.9.2",
    "@swc/core": "1.5.7",
    "@swc/helpers": "~0.5.11",
    "@types/d3": "7.4.3",
    "@types/jest": "29.5.14",
    "@types/jwt-encode": "1.0.3",
    "@types/lodash": "4.17.23",
    "@types/luxon": "3.4.2",
    "@types/node": "18.19.9",
    "@types/three": "^0.155.0",
    "@types/video.js": "7.3.56",
    "@typescript-eslint/eslint-plugin": "8.30.1",
    "@typescript-eslint/parser": "8.30.1",
    "@typescript-eslint/utils": "8.30.1",
    "autoprefixer": "^10.4.0",
    "cspell": "8.0.0",
    "eslint": "^8.57.0",
    "eslint-config-prettier": "10.1.2",
    "eslint-plugin-anti-trojan-source": "1.1.1",
    "eslint-plugin-import": "2.29.0",
    "eslint-plugin-jsdoc": "46.9.0",
    "eslint-plugin-playwright": "^0.15.3",
    "eslint-plugin-prettier": "5.0.1",
    "eslint-plugin-rxjs": "5.0.3",
    "eslint-plugin-rxjs-angular": "2.0.1",
    "eslint-plugin-sonarjs": "0.23.0",
    "eslint-plugin-unicorn": "49.0.0",
    "eslint-plugin-unused-imports": "4.1.4",
    "fake-indexeddb": "6.2.5",
    "googleapis": "173.0.0",
    "husky": "8.0.3",
    "jest": "29.7.0",
    "jest-environment-jsdom": "29.7.0",
    "jest-environment-node": "^29.4.1",
    "jest-preset-angular": "14.4.2",
    "jsonc-eslint-parser": "^2.1.0",
    "jwt-encode": "1.0.1",
    "lint-staged": "16.2.7",
    "msw": "2.1.2",
    "nx": "20.8.0",
    "postcss": "^8.4.5",
    "prettier": "3.1.0",
    "prettier-plugin-tailwindcss": "0.5.7",
    "react": "^18.2.0",
    "react-dom": "^18.2.0",
    "stylelint": "15.10.3",
    "stylelint-config-prettier-scss": "1.0.0",
    "stylelint-config-standard-scss": "11.0.0",
    "stylelint-no-unsupported-browser-features": "7.0.0",
    "stylelint-prettier": "4.0.2",
    "tailwindcss": "^3.0.2",
    "ts-jest": "^29.4.6",
    "ts-node": "10.9.1",
    "tsx": "4.22.4",
    "typescript": "5.9.3",
    "video.js": "8.9.0"
  },
  "optionalDependencies": {
    "@esbuild/linux-x64": "0.17.19",
    "@rollup/rollup-linux-x64-gnu": "4.34.8"
  },
  "workspaces": [
    "packages/*"
  ],
  "author": {
    "name": "Supercharge Ltd"
  },
  "engines": {
    "node": "20.19.1",
    "npm": "10.8.2"
  },
  "volta": {
    "node": "20.19.1",
    "npm": "10.8.2"
  },
  "overrides": {
    "form-data": "4.0.6",
    "socket.io-parser": "4.2.7",
    "dompurify": "3.4.17",
    "mermaid": "11.16.1",
    "lodash-es": "4.18.0",
    "uuid": "14.0.0",
    "ws": "8.21.0",
    "katex": "0.18.4"
  }
}
